import * as fromOrderReducer from './order.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBulkAcceptanceReducer from '../reducer/bulk-acceptance.reducer';
import * as fromAllCategoriesReducer from '../reducer/all-categories.reducer';
import { IOrderData } from '@app/@shared/Models/order.model';
import { IBulkAcceptanceData } from '@app/@shared/Models/bulk-acceptance.model';
import { ICategoriesData } from '@app/@shared/Models/all-categories.model';

// include all your reducer as key-value pairs [TODO:: Refactor via Lazy Loaded => Root Module Code will move to Order Module as for fetaure]

export const appBarrelReducer = {
    Order: fromOrderReducer.OrderReducer,
    BulkOrderAcceptance: fromBulkAcceptanceReducer.BulkAcceptanceReducer,
    AllCategories: fromAllCategoriesReducer.AllCategoriesReducer
}
export const OrderListFeature = createFeatureSelector('Order');
export const OrderResponse = createSelector(OrderListFeature, (state: IOrderData) => state);

export const BulkAcceptanceFeature = createFeatureSelector('BulkOrderAcceptance');
export const BulkAcceptanceSelector = createSelector(BulkAcceptanceFeature, (state: IBulkAcceptanceData) => state);

export const AllCategoriesFeature = createFeatureSelector('AllCategories');
export const AllCategoriesSelector = createSelector(AllCategoriesFeature, (state: ICategoriesData) => state);